'use client';

import useSWR from 'swr';
import { ALLERGIES_URL } from './constants';

export const useAllergies = () => {
  const { data } = useSWR(ALLERGIES_URL);
  return data;
};
